import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[rxRadioRow]',
})
export class RxRadioDirective {
  @Input()
  public value: any;

  constructor(public templateRef: TemplateRef<any>) {}
}
